module.exports = require('./helpers/bundle-url').getBundleURL('la5Oi') + "logo.7718c6df.svg";